export default num => (num >= 10 ? `${num}` : `0${num}`);



// WEBPACK FOOTER //
// ./src/utils/pad.js